export const REWORLD_CLIENT_ID = '46980923,2787961';
